import * as React from "react";

/**
 * Where lego's overlays (dialogs, sheets, menus, popovers, selects, tooltips)
 * portal to. Unset, Radix portals to `document.body`; a provider redirects every
 * overlay rendered beneath it into its element instead — used when a subtree
 * scopes its styling by class and the overlays it opens must stay inside that
 * scope.
 */
const PortalContainerContext = React.createContext<HTMLElement | null>(null);

export const PortalContainerProvider = PortalContainerContext.Provider;

/** The container for a Radix `Portal`'s `container` prop; `undefined` keeps `document.body`. */
export const usePortalContainer = (): HTMLElement | undefined =>
  React.useContext(PortalContainerContext) ?? undefined;
